// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__W3dNm","image":"Showcase_image__MyCHp","backBtn":"Showcase_backBtn__hRVkn","nextBtn":"Showcase_nextBtn__1ySFK","App":"Showcase_App__4h06O"};